import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["onClick"]

import { toRefs, useSlots, ref, provide } from 'vue'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    vertical: {
      type: Boolean,
      default: false
    },
    tabsPosition: {
      type: String,
      default: 'start'
    }
  },
  setup(__props) {

const props = __props;

  
  
  const { vertical, tabsPosition } = toRefs(props)
  
  // Funcionalidad para cambiar entre pestañas
  const slots: any = useSlots()
  const tabs = ref(slots.default().map(function (tab: any) {
    return {
      title: tab.props.title,
      faIcon: tab.props['fa-icon'],
    }
  }))
  
  const selectedTab = ref(tabs.value[0].title)
  provide('selectedTab', selectedTab)
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tabs", _unref(vertical) ? 'vertical' : ''])
  }, [
    _createElementVNode("ul", {
      class: _normalizeClass(["tabs__header", [_unref(tabsPosition)]])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: _normalizeClass([{ 'tab__selected': (selectedTab.value === tab.title) }, "tw-bg-[#00a0da] tw-rounded-full tw-text-white px-5 p-2 tw-font-medium tw-text-[18px]"]),
          onClick: ($event: any) => (selectedTab.value = tab.title)
        }, [
          (tab.faIcon !== null)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass(tab.faIcon)
              }, null, 2))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(tab.title), 1)
        ], 10, _hoisted_1))
      }), 128))
    ], 2),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})